module.exports = __webpack_public_path__ + "img/block2-1.f597d867.jpg";